import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../../pnp-settings.constants'
import { getDocumentTypes } from '../../../pnp-docs/pnp-docs.actions';

class pnpDocumentTypesGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService) {
        super($ngRedux, $state, NavigationService);
        this.$ngRedux = $ngRedux;
    }

    $onInit() {
        this.module = 'pnp';
        this.identifier = IDS.pnpSettingsDocumentTypeGrid;
        this.filterComponent = false;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.defaultTitle = 'Document Type List'

        this.columns = [
            {title: '#',                                                            mapper: 'doc_type_id'},
            {title: 'NAME',                                                         mapper: 'doc_type_name'},
            {title: 'CODE',                                                         mapper: 'doc_type_code'},
        ];


        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getDocumentTypes }
        )(this);

        this.dataAction = this.getDocumentTypes;

        this.init();
    }

    $onDestroy() {
        this.unsubscribe();
    }
}



export const pnpDocumentTypesGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onRemove: '&',
        onReset: '&'
    },
    controller: pnpDocumentTypesGridController,
    ...gridTpl
}
